import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Layout/AnalyticsLayout.module.scss';

interface ErrorDisplayProps {
  error?: string | null;
  isOfflineDataset?: boolean;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  isOfflineDataset = false,
}) => {
  if (!error && !isOfflineDataset) {
    return null;
  }

  return (
    <div className={styles.errorContainer}>
      <span>
        {isOfflineDataset ? (
          <div>
            This dataset is not available online. Please{' '}
            <Link to={'/contact'}>contact us</Link>
            {' for more information or data requests.'}
          </div>
        ) : (
          error
        )}
      </span>
    </div>
  );
};

export default ErrorDisplay;
